import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=f838c1ea"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"
import style0 from "./WorldMap.vue?vue&type=style&index=0&id=f838c1ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports